<template>
  <div class="v2-date-range-picker">
    <flat-pickr
      ref="picker"
      v-model="internalValue"
      class="v2-date-range-picker__input"
      :placeholder="placeholder"
      :config="mergedConfig"
      @on-change="onChange"
    />
    <svg
      class="v2-date-range-picker__icon"
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <polyline points="6 9 12 15 18 9" />
    </svg>
  </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component'
import { constants as c } from '@kingpin-global/kingpin-utils-frontend'

const { KP_DATE_FORMAT } = c

export default {
  name: 'V2DateRangePicker',
  components: {
    flatPickr,
  },
  props: {
    value: {
      type: [String, Array],
      default: null,
    },
    placeholder: {
      type: String,
      default: 'Select date range',
    },
    config: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      internalValue: this.value,
    }
  },
  computed: {
    mergedConfig() {
      // Default config
      const defaultConfig = {
        dateFormat: KP_DATE_FORMAT.CONFIG,
        mode: 'range',
      }

      // If custom config is provided, merge it (config from props takes precedence)
      // This allows VUE_FLATPICKR_MONTH_CONFIG to override defaults
      return {
        ...defaultConfig,
        ...this.config,
      }
    },
  },
  watch: {
    value(val) {
      this.internalValue = val
    },
  },
  methods: {
    onChange(dates) {
      this.$emit('change', dates)
    },
  },
}
</script>

<style lang="scss" scoped>
.v2-date-range-picker {
  position: relative;

  // Glass input — surface-2 + blur-sm. Matches V2Input recipe.
  &__input {
    width: 100%;
    padding: var(--v2-space-2) var(--v2-space-3);
    padding-right: var(--v2-space-8);
    font-family: var(--v2-font-sans);
    font-size: 0.875rem;
    color: var(--v2-foreground);
    // Trigger — translucent fill, no `backdrop-filter` (substrate-blur recipe).
    background: var(--v2-glass-surface-2);
    border: 1px solid var(--v2-glass-stroke);
    border-radius: var(--v2-radius-md);
    outline: none;
    min-height: 38px;
    transition: background 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease;

    &::placeholder {
      color: var(--v2-muted-foreground);
    }

    &:hover:not(:focus) {
      border-color: var(--v2-glass-stroke-strong);
    }

    &:focus {
      border-color: var(--v2-primary);
      box-shadow: 0 0 0 3px oklch(0.62 0.21 295 / 0.25);
    }
  }

  &__icon {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    color: var(--v2-muted-foreground);
    pointer-events: none;
  }
}
</style>
